module.exports = __webpack_public_path__ + "static/media/circleColor_facebook.2406386b.svg";